import { render, staticRenderFns } from "./WelfareDetail.vue?vue&type=template&id=d8c6f298&scoped=true"
import script from "./WelfareDetail.vue?vue&type=script&lang=js"
export * from "./WelfareDetail.vue?vue&type=script&lang=js"
import style0 from "./WelfareDetail.vue?vue&type=style&index=0&id=d8c6f298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c6f298",
  null
  
)

export default component.exports